import { Canvas } from "@react-three/fiber";
import React from "react";
import { Props as CanvasProps } from "@react-three/fiber";

export type NvsSceneProps = CanvasProps;

export const NvsAuthorableScene: React.FC<NvsSceneProps> = ({
  children,
  ...props
}) => {
  return <Canvas {...props}>{children}</Canvas>;
};
